<template>
  <!-- danger -->
  <div
    ref="contentRef"
    class="mod-content mod-view-text"
    :class="{ 'tw-whitespace-pre-line': !content.includes('<p>') }"
    v-html="
      formatDescription(
        Settings.allowLinks ? addBlankTargets(content) : stripLinks(content)
      )
    "
  />
</template>

<script>
import { watchEffect, nextTick } from 'vue'
import hljs from 'highlight.js/lib/common'
import { Settings } from '@config/game.js'
import { watch, ref } from 'vue'
import {
  formatDescription,
  attachLinkEvents,
  addBlankTargets,
  stripLinks,
} from '@helpers/formatContent.js'

hljs.configure({ ignoreUnescapedHTML: true })

export default {
  props: {
    content: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const contentRef = ref(null)

    watchEffect(() => {
      if (props.content) {
        // Run on next tick after DOM has finished rendering
        nextTick(() => {
          document
            .querySelectorAll('pre code')
            .forEach((block) => delete block.dataset.highlighted)
          hljs.highlightAll()

          attachLinkEvents(contentRef.value)
        })
      }
    })

    watch(
      () => Settings.value.allowLinks,
      () => {
        nextTick(hljs.highlightAll)
      }
    )

    return {
      formatDescription,
      addBlankTargets,
      stripLinks,
      contentRef,
      Settings,
    }
  },
}
</script>

<style>
@import url('/public/css/github-dark-dimmed.css');
</style>
